var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"documents"},[_c('ul',{staticClass:"documents__list"},_vm._l((_vm.documents),function(item,key){return _c('li',{key:key,staticClass:"documents__item"},[_c('a',{attrs:{"href":item.url,"target":"_blank"}},[_c('app-icon',{attrs:{"name":"pdf"}}),_c('span',[_vm._v(_vm._s(item.name))])],1)])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }